
import Modal from 'bootstrap/js/dist/modal';

jQuery(document).ready(($) => {
  document.documentElement.classList.remove('no-js');
  initApp($);
  // window.Location = require('./modules/global/location');
});

const initApp = ($) => {
  let $body = $('body');

  // GLOBAL
  const Banners = require('./modules/global/banners');
  Banners.init();

  const Forms = require('./modules/global/forms');
  Forms.init();

  const Heros = require('./modules/global/heros');
  Heros.init();

  // const Location = window.Location = require('./modules/global/location');
  // Location.init();

  const MainMenu = require('./modules/global/mainMenu');
  MainMenu.init();

  // const MapClientTimeToService = window.MapClientTimeToService = require('./modules/global/mapClientTimeToService');

  // PAGE DETECTION
  // if ($body.hasClass('page-home')) {
  //   const FrontPage = require('./modules/pages/frontPage');
  //   FrontPage.init();
  // }

  if ($body.hasClass('page-gallery')) {
    const GalleryPage = require('./modules/pages/galleryPage');
    GalleryPage.init();
  }

  if ($body.hasClass('page-menu')) {
    const MenuPage = require('./modules/pages/menuPage');
    MenuPage.init();
  }
};
